// @flow
import tinycolor from 'tinycolor2'

const colors = {
  black: 'rgba(0, 0, 0, 0.6)',
  white: 'rgba(255, 255, 255, 0.6)'
}

const colorLabelStyle = (item: any, outline: boolean) => {
  return outline
    ? {
        borderColor: item.color,
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        color: item.color
      }
    : {
        backgroundColor: item.color,
        color: fontColor(item.color)
      }
}

const fontColor = (background: any) => {
  if (background) {
    return tinycolor(background).getBrightness() > 150 ? colors.black : colors.white
  }
  return colors.black
}

const self = {
  colorLabelStyle,
  fontColor
}

export default self
